import React from 'react';
import config from 'react-global-configuration';
import { FormTextField } from '@uncinc/uncinc-react-kitchen-sink';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';

const PostalCodeAutocomplete = ({ title, fieldName, localityField, addressField, ...props }) => {
  const language = useSelector((state) => state.getIn(['ui', 'language']));
  const { setFieldValue } = useFormikContext();

  const postalCodeBillingLookup = null;
  const onChangePostalCodeBilling = (value) => {
    if (postalCodeBillingLookup) {
      clearTimeout(postalCodeBillingLookup);
    }

    // Only apply when format is correct.
    if (!value.match(/^(?:NL-)?(\d{4})\s*([A-Z]{2})$/i)) {
      return;
    }

    setTimeout(() => {
      const API_URL = config.get('API_URL');
      const MULTILINGUAL = config.get('MULTILINGUAL', true);
      const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
      fetch(`${PATH}/api/postal_code/lookup?q=${value}`, {
        method: 'GET',
        credentials: 'include',
      })
        .then((result) => result.json())
        .then((data) => {
          // Only apply when one result is found.
          if (data.length >= 1) {
            setFieldValue(localityField, data[0].woonplaats);
            setFieldValue(addressField, data[0].straatnaam);
          }
        });
    }, 500);
  };

  return (
    <FormTextField
      title={title}
      fieldName={fieldName}
      onChange={(e) => onChangePostalCodeBilling(e.target.value)}
      {...props}
    />
  );
};

export default PostalCodeAutocomplete;
